/* eslint-disable no-unused-vars */
import DialogVue from "./v-dialog.vue";
var Dialog = {};
Dialog.install = function(Vue, options) {
  const len = document.getElementsByClassName("v-dialog").length;
  if (len) {
    return;
  }

  Vue.prototype.$vDialog = {
    show(options) {
      const DialogVueTpl = Vue.extend(DialogVue);
      const $vm = new DialogVueTpl();
      const tpl = $vm.$mount().$el;
      document.body.appendChild(tpl);
      
      if (typeof options === "string") {
        $vm.contentHtml = options;
      } else if (typeof options === "object") {
        Object.assign($vm, options);
      }
      $vm.show = true;
    }
  };
};
export default Dialog;
